import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CommonTableGraph from '../../../../charts/CommonTableGraph';
const VersionHistoryTable = ({ verHistory = [] }) => {
    let tableFormat = verHistory.map((row) => {
        return {
            Version: row.version,
            _Time: row.timestamp,
        };
    });
    if (tableFormat.length === 0)
        tableFormat = [{ Version: 'Version not found', _Time: undefined }];
    return _jsx(CommonTableGraph, { data: tableFormat });
};
export default VersionHistoryTable;
